import Paragraph from "@/components/atoms/Paragraph";
import SHeading from "@/components/atoms/SHeading";
import { MIDDLE_FONT_SIZE } from "@/constants";
import React from "react";

type SFeatureCardProps = {
  heading: string;
  description: string | React.ReactNode;
  className?: string;
  icon: React.ElementType;
};

const SFeatureCard: React.FC<SFeatureCardProps> = ({
  heading,
  description,
  icon: Icon,
  className,
}) => {
  const renderDescription = () => {
    if (typeof description === "string") {
      return <Paragraph text={description} size={MIDDLE_FONT_SIZE} />;
    }
    return description;
  };

  return (
    <div
      className={`col-span-1 rounded-3xl bg-white h-full flex flex-col justify-between ${className}`}
    >
      <div className="flex gap-4 p-4">
        <div className="w-1/3 flex justify-center items-center">
          <div className="bg-primary p-4 rounded-full">
            <Icon />
          </div>
        </div>

        <div className="flex-1 flex flex-col gap-2 overflow-hidden text-ellipsis">
          <SHeading text={heading} className="!leading-normal" />
          {renderDescription()}
        </div>
      </div>
    </div>
  );
};

export default SFeatureCard;
